import { CSSProperties, memo, useRef } from 'react'
import { URL_MFC_SHARE_IFRAMES } from '../../constants/urls'
import { safeObj } from '../../utilities/safe'
import IFrame from './Modals/common/IFrame'

const SHARE_IFRAME_URL = `${URL_MFC_SHARE_IFRAMES}video_carousels/`

interface IShareFreeAlbums {
    name?: string
    width?: number
    albums?: number
    style?: CSSProperties
}

const ShareFreeAlbums = (props: IShareFreeAlbums) => {
    const ref = useRef<HTMLDivElement>(null)
    const { albums, name, style, width } = safeObj(props)
    if (!width) return null
    const height = (width * 9) / 16 + (albums === 1 ? 0 : 25)

    return (
        <div style={style} ref={ref}>
            <IFrame
                disableScrolling={true}
                src={SHARE_IFRAME_URL + name}
                styleOverrides={{ height, width: '100%' }}
                allowFullScreen={true}
            />
        </div>
    )
}

export default memo(ShareFreeAlbums)
